import { IcUser } from '@assets/icons/24x24';
import { Field as ChakraField, Fieldset, VStack } from '@chakra-ui/react';
import { CockpitFormSeparator } from '@components/cockpit/layouts/CockpitFormLayout';
import { FormInputNumber, FormInputString } from '@components/common/form';
import ModifiedTag from '@components/common/form/ModifiedField';
import { PasswordInput } from '@components/ui/password-input';
import RequiredIndicator from '@components/ui/RequiredIndicator';
import { hasChanged, isInvalid } from '@utils/validation/validation.utils';
import { Field, FieldInputProps, FormikProps, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';

import { GetSensorOrSubSensorConfigurationWithShorthand } from '@/types/sensor/sensorInstallation.types';
import { SensorTypeEnum } from '@/types/sensor/sensors';

type AeroscopeFormType = Partial<GetSensorOrSubSensorConfigurationWithShorthand<SensorTypeEnum.AEROSCOPE>>;

export function AeroscopeConnectivityForm() {
  return (
    <Fieldset.Root>
      <VStack width="100%" gap={5} alignItems="start">
        <FormInputString label="host" />
        <FormInputNumber label="port" max={65535} />
        <CockpitFormSeparator />
        <FormInputNumber label="timeoutThreshold" suffix="ms" width="150px" />
        <CockpitFormSeparator />
        <FormInputString label="controlUrl" i18nKey="components.sensorInstallation.form.aeroscope.controlUrl" />
      </VStack>
    </Fieldset.Root>
  );
}

export function AeroscopeAuthentForm() {
  const { touched, errors, initialValues, values } = useFormikContext<AeroscopeFormType>();

  return (
    <Fieldset.Root>
      <VStack width="100%" gap={5} alignItems="start">
        <FormInputString
          label="username"
          i18nKey="components.sensorInstallation.form.aeroscope.username"
          icon={IcUser}
        />
        <ChakraField.Root variant="cockpit" invalid={isInvalid('password', touched, errors)} required>
          <ChakraField.Label width="100%" height="20px">
            <FormattedMessage id="components.sensorInstallation.form.aeroscope.password" />
            <RequiredIndicator />
            {hasChanged('password', initialValues, values) && <ModifiedTag />}
          </ChakraField.Label>
          <Field name="password">
            {({ field, form }: { field: FieldInputProps<string>; form: FormikProps<AeroscopeFormType> }) => (
              <PasswordInput {...field} showLockIcon onChange={form.handleChange} onBlur={form.handleBlur} />
            )}
          </Field>
        </ChakraField.Root>
      </VStack>
    </Fieldset.Root>
  );
}
